<template>
</template>
<script>
import axios from 'axios'
import { toDecrypt } from '@/libs/secret'
import store from '@/store'
export default {
    beforeRouteEnter() {
        const pathURL = window.location.pathname.split('/')[2]
        axios
        .get(`${process.env.VUE_APP_BASE_URLS}lnk/${pathURL}`)
        .then((response) => {
            let ecr = toDecrypt(response.data.res, store.state.secretKey)
            const URLRedirect = JSON.parse(ecr)
            window.location = URLRedirect.original.data
        })
        .catch((error) => {
            if (error.response.status === 404) {
                // whatever, nbd
                window.location.replace(window.location.origin);
            }else if (error.response.status === 401){
                window.location.replace(window.location.origin);
            }
        })
    },
}
</script>